import React from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';

type Props = {
  className?: string;
}

export default function Tag({className, children}: React.PropsWithChildren<Props>) {
  const styles = createUseStyles({
    fitContent: {
      width: 'fit-content'
    }
  })();
  return (
    <span
      className={cn(className, 'text-gray-dark border border-gray-dark rounded mr-2 px-1 text-sm inline-block',
        styles.fitContent)}>
      {children}
    </span>
  );
}
